import Icon from '@material-ui/icons/Link'
import React from 'react'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import {
    AutocompleteInput,
    BooleanField,
    BooleanInput,
    Create,
    Datagrid,
    DeleteButton,
    Edit,
    EditButton,
    NumberInput,
    ReferenceInput,
    ReferenceManyField,
    required,
    Show,
    SimpleForm,
    Tab as TabRa,
    TabbedShowLayout,
    TextField,
    TextInput,
    TopToolbar,
    useShowController,
} from 'react-admin'
import { Button } from '@material-ui/core'

export const EnterpriseProductIcon = Icon

const productOptionText = (product) =>
    product
        ? product.providerName
            ? `${product.name} (${product.providerName})`
            : product.name
        : ''

// O backend trata "" como null; NumberInput devolve null quando o campo é limpo
const toNullable = (value) =>
    value === null || value === undefined ? '' : value

const enterpriseShowPath = (enterpriseId) =>
    `/admin/enterprises/${enterpriseId}/show/1`

export const EnterpriseProductCreate = (props) => {
    const location = useLocation()
    const enterpriseId = location.state && location.state.enterpriseId

    const transform = ({ copyFareAges, ...data }) => ({
        enterpriseId: data.enterpriseId,
        productId: data.productId,
        fareCode: toNullable(data.fareCode),
        markup: toNullable(data.markup),
        active: data.active,
        // sem fareAges o backend copia as tarifas base do produto
        ...(copyFareAges ? {} : { fareAges: [] }),
    })

    return (
        <Create
            {...props}
            title="Vincular produto"
            mutationMode="pessimistic"
            transform={transform}
        >
            <SimpleForm
                redirect="show"
                initialValues={{
                    enterpriseId,
                    active: true,
                    copyFareAges: true,
                }}
            >
                <ReferenceInput
                    label="Empresa"
                    source="enterpriseId"
                    reference="admin/enterprises"
                    validate={[required()]}
                    disabled={!!enterpriseId}
                >
                    <AutocompleteInput optionText="corporateName" />
                </ReferenceInput>
                <ReferenceInput
                    label="Produto"
                    source="productId"
                    reference="admin/products"
                    sort={{ field: 'name', order: 'ASC' }}
                    filterToQuery={(q) => ({ q })}
                    perPage={50}
                    validate={[required()]}
                >
                    <AutocompleteInput optionText={productOptionText} />
                </ReferenceInput>
                <TextInput label="Código Tarifa" source="fareCode" />
                <NumberInput label="Markup" source="markup" />
                <BooleanInput label="Ativo" source="active" />
                <BooleanInput
                    label="Copiar tarifas do produto"
                    source="copyFareAges"
                    helperText="Desmarque para criar o vínculo sem tarifas"
                />
            </SimpleForm>
        </Create>
    )
}

export const EnterpriseProductEdit = (props) => {
    const transform = (data) => ({
        id: data.id,
        fareCode: toNullable(data.fareCode),
        markup: toNullable(data.markup),
        active: data.active,
    })

    return (
        <Edit
            {...props}
            title="Editar vínculo"
            mutationMode="pessimistic"
            transform={transform}
        >
            <SimpleForm redirect="show">
                <TextField label="Empresa" source="Enterprise.corporateName" />
                <TextField label="Produto" source="Product.name" />
                <TextInput label="Código Tarifa" source="fareCode" />
                <NumberInput label="Markup" source="markup" />
                <BooleanInput label="Ativo" source="active" />
            </SimpleForm>
        </Edit>
    )
}

const ShowActions = ({ basePath, data }) => (
    <TopToolbar>
        {data && (
            <Button
                component={Link}
                to={enterpriseShowPath(data.enterpriseId)}
                color="primary"
            >
                Voltar para a empresa
            </Button>
        )}
        <EditButton basePath={basePath} record={data} />
    </TopToolbar>
)

export const EnterpriseProductShow = (props) => {
    const { record } = useShowController(props)

    if (!record) return null

    return (
        <Show {...props} title="Vínculo empresa x produto" actions={<ShowActions />}>
            <TabbedShowLayout>
                <TabRa label="Vínculo">
                    <TextField label="Empresa" source="Enterprise.corporateName" />
                    <TextField label="Produto" source="Product.name" />
                    <TextField
                        label="Nome (Provedor)"
                        source="Product.providerName"
                    />
                    <TextField label="Código Tarifa" source="fareCode" />
                    <TextField label="Markup" source="markup" />
                    <BooleanField label="Ativo" source="active" />
                </TabRa>

                <TabRa label="Tarifas">
                    <ReferenceManyField
                        reference="admin/enterpriseProductFareAges"
                        target="enterpriseProductId"
                        addLabel={false}
                        sort={{ field: 'startAge', order: 'ASC' }}
                        perPage={100}
                    >
                        <>
                            <TopToolbar>
                                <Button
                                    component={Link}
                                    variant="contained"
                                    to={{
                                        pathname: `/admin/enterpriseProductFareAges/create`,
                                        state: { enterpriseProductId: record.id },
                                    }}
                                    color="primary"
                                >
                                    Adicionar Tarifa
                                </Button>
                            </TopToolbar>
                            <Datagrid>
                                <TextField
                                    label="Idade Inicial"
                                    source="startAge"
                                />
                                <TextField label="Idade Final" source="endAge" />
                                <TextField label="Valor" source="value" />
                                <TextField label="Moeda" source="currency" />
                                <EditButton />
                                <DeleteButton
                                    redirect={false}
                                    mutationMode="pessimistic"
                                />
                            </Datagrid>
                        </>
                    </ReferenceManyField>
                </TabRa>
            </TabbedShowLayout>
        </Show>
    )
}
